<template>
<div class="hot-play">
    <div class="blk-title">看看大家去哪玩</div>
    <div class="list-box">
        <ul class="list">
            <li v-for="(item,index) in list " :key="index">
                <a :href="item.url" target="_blank" class="cover-img"><div class="img-box"><img :src="item.img" alt=""></div></a>
                <a :href="item.url" target="" class="title">{{item.title}}</a>
            </li>
        </ul>
    </div>
</div>
</template>
<script>
export default {
    name:'HotPlay',
    data(){
        return {
            list :[
                {
                    title:'多伦多及周边特色小镇，值得逐个打卡！',
                    url:'https://news.yorkbbs.ca/topics/1779134.html',
                    img:'https://media3.imgyb.xyz/media/v1/image/dafe1e7f291c0135139059c113b57f7a.jpeg',
                },
                {
                    title:'多伦多地区最受家庭欢迎的亲子骑车路线',
                    url:'https://news.yorkbbs.ca/detail/travel/262cdb1d-c90a-4216-aeab-b15249d9858c',
                    img:'https://media2.imgyb.xyz/media/v1/image/dfb4ca52cbbbf5ce3e91756a59a8f1ea.jpeg',
                },
                {
                    title:'多伦多周边游：春季值得“离家出走”的5大度假村！',
                    url:'https://news.yorkbbs.ca/detail/local/5126ad02-6cd3-460c-8c75-92004f8618a5',
                    img:'https://media4.imgyb.xyz/media/v1/image/bfb53cb5ac46204b6ee75cb5c4d5f52d.jpeg',
                },
                {
                    title:'尼亚加拉大瀑布省钱攻略！各种游玩PASS帮你省',
                    url:'https://news.yorkbbs.ca/detail/travel/ee1e76c9-2173-4220-974c-e60245aa93fe',
                    img:'https://media5.imgyb.xyz/media/v1/image/6f2c99ef00e392ffa03607bca4409668.jpeg',
                },
                {
                    title:'多伦多5条风景优美hiking小径！有瀑布、森林风光无限！',
                    url:'https://forum.yorkbbs.ca/detail/9000b3fb-0564-4104-8721-4f7521cd6ef0?topic=travel',
                    img:'https://media3.imgyb.xyz/media/v1/image/d87da62bffc684387441f4a3fd594893.jpeg',
                },
                {
                    title:'盘点多伦多周边的6个动物园：码住收藏，去打卡！',
                    url:'https://forum.yorkbbs.ca/detail/9253fbd5-fb2c-4158-b7a4-9bcbf1d6c46d?topic=chat',
                    img:'https://media4.imgyb.xyz/media/v1/image/865f2e44a744d3a59be329c546b10d37.jpeg',
                },
            ]
        }
    }
}
</script>
<style lang="less" scoped>
.hot-play{
    margin-top: 30px;
    .blk-title{

        font-size: 26px; text-align: center; margin-bottom: 20px ;
    }
    .list-box{
        background: #fff; border-radius: 4px; padding: 20px 20px 0;
        ul{
            display: flex; flex-wrap: wrap; margin: 0 -15px;
            li{
                width: 33.33%; padding: 0 15px; box-sizing: border-box; margin-bottom: 30px;
                a{
                    display: block;
                    position: relative;
                }
                .img-box{
                    position: relative; padding-bottom: 62.5%; overflow: hidden; border-radius: 4px;
                    img{
                        position: absolute; left: 0;  top: 0; width: 100%; height: 100%; object-fit: cover; transition: all 200ms linear;
                    }
                    &:hover{
                        img{transform: scale(1.2); }
                    }
                }
                .title{
                    font-size: 16px; line-height: 26px; color: #111; margin-top: 15px;
                    &:hover{color: #e43a3a;}
                }
            }
        }
    }
}
@media screen and (max-width:768px){
    .hot-play{
        margin-top: 20px;
        .blk-title{font-size: 18px;}
        .list-box{
            padding: 10px 10px 0;
            ul{
                margin: 0 -10px;
                li{
                    width:50%; padding: 0 10px; margin-bottom: 15px;
                }
            }
        }
    }
}
</style>